<template>
  <div class="modal-mask" v-show="showCategoryModal" transition="modal">
    <div class="modal-wrapper">
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header">Категория</slot>
        </div>

        <div class="modal-body">
          <div class="modal-body">
            <b-tabs
              v-if="category.translations && category.translations.length > 0"
              content-class="mt-3"
              fill
              style="margin: 20px 0; overflow-x: hidden; max-height: 500px"
            >
              <b-tab
                v-for="translation in category.translations"
                :title="translation.locale"
                active
                :key="translation.id"
              >
                <div class="form-group">
                  <label>Наименование свойства</label>
                  <input
                    type="text"
                    class="form-control"
                    :value="translation.title"
                    disabled
                  />
                </div>
              </b-tab>

              <b-tab v-if="category.language" :title="category.language" active>
                <div class="form-group">
                  <label
                    >Наименование свойства
                    <span class="btn btn-danger m-0 p-0">новое</span>
                  </label>
                  <input
                    type="text"
                    class="form-control"
                    :value="category[category.language + '_title']"
                    disabled
                  />
                </div>
              </b-tab>
            </b-tabs>
            <div v-else>
              <div class="form-group">
                <label>Наименование [RU]</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="category.ru_title"
                  disabled
                />
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Код [Если пустой подставится порядковый ID]</label>
            <input
              type="text"
              class="form-control"
              disabled
              v-model="category.code"
            />
          </div>
          <div class="form-group">
            <label>Категория</label>
            <select class="form-control" v-model="category.parent_id" disabled>
              <option
                :selected="
                  category.parent_id === 0 || category.parent_id === undefined
                "
                value="0"
              >
                Основная Категория
              </option>
              <option
                :selected="category.parent_id !== 0"
                :value="category.parent_id"
              >
                Выбранная категория: <br />
                <span v-if="typeof this.parentCategory.code != 'undefined'">
                  {{ this.parentCategory.code }}

                  <span v-if="typeof this.parentCategory.title != 'undefined'">
                    {{ this.parentCategory.title }}
                  </span>
                </span>
              </option>
            </select>
          </div>
          <div class="alert alert-danger" v-if="comment">
            <b>Комментарий:</b> {{ comment }}
          </div>
        </div>

        <div class="modal-footer">
          <slot name="footer">
            <button
              class="modal-button btn btn-danger"
              @click="
                updateTab('update', { modal: 'category', visible: false })
              "
            >
              Закрыть
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET } from "@/shared/api";

export default {
  props: {
    category: {},
    showCategoryModal: false,
    languages: [],
    comment: null,
  },
  data() {
    return {
      categorySearchData: [],
      parentCategory: {},
    };
  },
  methods: {
    updateTab(event, state) {
      this.$emit(event, state);
    },
    getCategoryByID() {
      if (this.showCategoryModal === false) {
        return null;
      }
      if (typeof this.category.parent_id != "undefined") {
        GET([], "/getCategory/" + this.category.parent_id, this, false).then(
          (response) => {
            this.parentCategory = response;
          }
        );
      }
    },
  },
  watch: {
    showCategoryModal: {
      handler: "getCategoryByID",
    },
  },
};
</script>

<style scoped></style>
